import styled from "styled-components";

export default styled.nav`
  z-index: 9;
  position: sticky;
  top: 0;
  padding: 1rem;
  transition: background-color 0.5s ease-in-out;
  ${({ isScrolled, theme }) =>
    isScrolled &&
    `
    background: ${theme.colors.nav_bg};
    backdrop-filter: blur(15px);
    transition: background-color 0.5s ease-in-out;
  `}

  @media screen and (max-width: 769px) {
    background: ${({ theme }) => theme.colors.nav_bg_2} !important;
  }
  .nav-container {
    min-height: 42px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .brand {
      width: 128.6px;
      max-width: 128.6px;
      min-width: 128.6px;
    }
    .addres-info__toogle-theme {
      display: flex;
      align-items: center;
      gap: 30px;
      .toggle-theme {
        cursor: pointer;
        span {
          display: flex;
          align-items: center;
          .slash-between {
            user-select: none;
            color: ${({ theme }) => theme.colors.ellipse_1};
          }
          path,
          .slash-between {
            fill: ${({ theme }) => theme.colors.ellipse_1};
          }
        }
      }
      .addres-info {
        display: flex;
        align-items: center;
        gap: 13px;
        font-size: 13px;
        * {
          color: ${({ theme }) => theme.colors.ellipse_1};
        }
        .addres-info__balance {
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
  .wallet-address-button {
    padding: 10px 13px;
    > div {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    svg path {
      stroke: ${({ theme }) => theme.colors.ellipse_1};
    }
  }
  .wallet-address-button-container {
    position: relative;

    .dropdown-settings {
      width: 100%;
      opacity: 0;
      pointer-events: none;
      transition: all 0.2s;

      position: absolute;
      background: ${({ theme }) => theme.colors.ellipse_36};
      border: 0.8px solid ${({ theme }) => theme.colors.ellipse_37};
      border-radius: 7px;
      padding: 10px 19px;
      button {
        width: 100%;
        cursor: pointer;
        background: transparent;
        border: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        svg path {
          fill: ${({ theme }) => theme.colors.ellipse_1};
        }
      }
    }
    :hover,
    :focus {
      .dropdown-settings {
        transition: all 0.2s;
        opacity: 1;
        pointer-events: auto;
      }
    }
    .dropdown-settings {
      :hover,
      :focus {
        transition: all 0.2s;
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
  @media screen and (max-width: 769px) {
    .addres-info__toogle-theme {
      gap: 10px !important;
    }
    .nav-container {
      flex-wrap: wrap;
      row-gap: 10px;
      .wallet-address-button {
        gap: 1rem;
      }
      .addres-info__toogle-theme .addres-info * {
        font-size: 12px;
      }
      .addres-info__balance {
        display: none;
      }
    }
  }
`;
